"use strict";

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Libp2pCryptoIdentity = exports.Libp2pCryptoPublicKey = exports.privateKeyFromString = exports.privateKeyToString = exports.publicKeyToString = void 0;

var threads_crypto_1 = require("@textile/threads-crypto");

var multibase_1 = __importDefault(require("multibase"));

function publicKeyToString(key) {
  return multibase_1.default.encode("base32", threads_crypto_1.keys.marshalPublicKey(key)).toString();
}

exports.publicKeyToString = publicKeyToString;

function privateKeyToString(key) {
  return multibase_1.default.encode("base32", threads_crypto_1.keys.marshalPrivateKey(key)).toString();
}

exports.privateKeyToString = privateKeyToString;

function privateKeyFromString(str) {
  return threads_crypto_1.keys.unmarshalPrivateKey(multibase_1.default.decode(str));
}

exports.privateKeyFromString = privateKeyFromString;

var Libp2pCryptoPublicKey = /*#__PURE__*/function () {
  function Libp2pCryptoPublicKey(key) {
    _classCallCheck(this, Libp2pCryptoPublicKey);

    this.key = key;
  }
  /**
   * Verify the given signed data.
   * @param data The data to verify.
   * @param sig The signature to verify.
   */


  _createClass(Libp2pCryptoPublicKey, [{
    key: "verify",
    value: function verify(data, sig) {
      return this.key.verify(data, sig);
    }
    /**
     * Returns base32 encoded Public key representation.
     */

  }, {
    key: "toString",
    value: function toString() {
      return publicKeyToString(this.key);
    }
    /**
     * The raw bytes of the Public key.
     */

  }, {
    key: "bytes",
    get: function get() {
      return this.key.bytes;
    }
  }]);

  return Libp2pCryptoPublicKey;
}();

exports.Libp2pCryptoPublicKey = Libp2pCryptoPublicKey;

var Libp2pCryptoIdentity = /*#__PURE__*/function () {
  function Libp2pCryptoIdentity(key) {
    _classCallCheck(this, Libp2pCryptoIdentity);

    this.key = key;
  }
  /**
   * Signs the given data with the Private key,
   * @param data Data to be signed.
   */


  _createClass(Libp2pCryptoIdentity, [{
    key: "sign",
    value: function sign(data) {
      return this.key.sign(data);
    }
    /**
     * Returns the Public key.
     */

  }, {
    key: "toString",

    /**
     * Returns base32 encoded private key representation.
     */
    value: function toString() {
      return privateKeyToString(this.key);
    }
    /**
     * Creates key key from base32 encoded string representation
     * @param str
     */

  }, {
    key: "public",
    get: function get() {
      return new Libp2pCryptoPublicKey(this.key.public);
    }
    /**
     * Create a random Ed25519 Identity.
     */

  }], [{
    key: "fromRandom",
    value: function fromRandom() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = Libp2pCryptoIdentity;
                _context.next = 3;
                return threads_crypto_1.keys.supportedKeys.ed25519.generateKeyPair();

              case 3:
                _context.t1 = _context.sent;
                return _context.abrupt("return", new _context.t0(_context.t1));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "fromString",
    value: function fromString(str) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = Libp2pCryptoIdentity;
                _context2.next = 3;
                return privateKeyFromString(str);

              case 3:
                _context2.t1 = _context2.sent;
                return _context2.abrupt("return", new _context2.t0(_context2.t1));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }]);

  return Libp2pCryptoIdentity;
}();

exports.Libp2pCryptoIdentity = Libp2pCryptoIdentity;